// ----------------------------------------------------------------------------
// Component: Login
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import "./_login.scss";

//

document.addEventListener("DOMContentLoaded", function () {
  const urlPath = window.location.pathname;
  const isLoginPage = urlPath === "/account/login";

  const urlParams = new URLSearchParams(document.location.search);
  const hasRedirect = urlParams.has("checkout_url");

  if (isLoginPage) {
    if (hasRedirect) {
      let redirectTo = urlParams.get("checkout_url");

      redirectTo = redirectTo.replace("/", "%2F");
      const signupLink = document.querySelector(".form__register-link");
      signupLink.href = signupLink.href + "?checkout_url=" + redirectTo;
    }
  }
});
